import React, { useState, useEffect, useRef } from 'react'
import "./Home2.scss"
import { Link } from "react-router-dom"
import about from "../../Assets/Images/about.jpg"
import p1 from "../../Assets/Images/Products/Multivitamin Range.jpg"
import p2 from "../../Assets/Images/Products/Neuropathy Management.jpg"
import p3 from "../../Assets/Images/Products/Antidepressent Range.jpg"
import p4 from "../../Assets/Images/Products/Alzhiemer's Management  Anti Psychotic Range.jpg"
import p5 from "../../Assets/Images/Products/Anti Epileptic Range  Anti Migraine Range.jpg"
import p6 from "../../Assets/Images/Products/Anti-Vertigo Range.jpg"
import p7 from "../../Assets/Images/Products/PPI (Proton Pump Inhibitors) Range.jpg"
import p8 from "../../Assets/Images/Products/Anti Migraine Range.jpg"
import p9 from "../../Assets/Images/Products/Anti Psychotic Range.jpg"

import slider from "../../Assets/Images/slider.png"
import sliderbg from "../../Assets/Images/3243.png"
import contact from "../../Assets/Images/contact.png"
import fb from "../../Firebase/firebase";
import emailjs from '@emailjs/browser';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const DB = fb.firestore()
const CF = DB.collection('Contact_Form');


const Home = () => {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  }, []);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = e.clientX - left - width / 2; // Centering effect
    const y = e.clientY - top - height / 2;
    setPosition({ x, y });
  };

  const username = "gss  lifesciences";
  const [animatedText, setAnimatedText] = useState([]);

  useEffect(() => {
    setAnimatedText(
      username.split("").map((char, index) => (
        <span
          key={index}
          className={char === " " ? "space-char" : "float-char"}
          style={{ animationDelay: `${Math.random() * 2}s` }}
        >
          {char === " " ? "\u00A0" : char}  {/* Ensures space is visible */}
        </span>
      ))
    );
  }, []);

  // contact form ====================================
  const form = useRef();
  const [userData, setUserData] = useState({
    FirstName: "",
    Email: "",
    Mobile: "",
    Message: "",
    LastName: ""
  });

  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUserData({ ...userData, [name]: value });
  }

  //connect with firebase
  const SubmitData = async (e) => {
    e.preventDefault();
    const { FirstName, LastName, Email, Mobile, Message } = userData;
    if (FirstName && LastName && Email && Mobile && Message) {


      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(userData.Email)) {
        toast.warning('Please enter a valid email address');
        return
      }

      if (typeof Mobile !== "undefined") {

        var pattern = new RegExp(/^[0-9\b]+$/);

        if (!pattern.test(userData.Mobile)) {
          toast.warning("Please enter only number.");
          return

        } else if (userData.Mobile.length !== 10) {
          toast.warning("Please enter 10 digit Mobile number.");
          return
        }
      }

      try {

        CF.add({
          FirstName: FirstName,
          LastName: LastName,
          Email: Email,
          Mobile: Mobile,
          Message: Message
        }).then((docRef) => {
          toast.success('Message Sent Successfully');
        }).catch((error) => {
          console.error("error:", error);
        });

        emailjs.sendForm('service_blv6m39', 'template_jj202jo', form.current, 'kNeMTvdXn2pKHy2m6')
          .then((result) => {
            console.log(result.text);

          }, (error) => {
            console.log(error.text);
          });

        setUserData({
          FirstName: "",
          LastName: "",
          Email: "",
          Mobile: "",
          Message: ""
        })

        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
        toast.warning("Error adding document")
      }
    }
    else {
      toast.warning('Please fill the data', {
      });
    }
  };
  //contact form ends ==========================================================

  return (
    <div>
      <ToastContainer
        className="toast-container-right-center"
        toastClassName="custom-toast"
        bodyClassName="custom-body"
        hideProgressBar={true}

      />
      <>

        <div className="slider2">
          <svg className='shape' xmlns="http://www.w3.org/2000/svg" width="1792" height="334" viewBox="0 0 1792 334" fill="none"><mask id="divider1-1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1792" height="334"><path fill="#e05e50" d="M0 0h1792v334H0z"></path></mask><g mask="url(#divider1-1)"><path d="M0 318h856.534c37.3 0 73.262-13.897 100.869-38.979l83.697-76.042c27.6-25.082 63.57-38.979 100.87-38.979H1792v178.519H0V318z" fill="#e05e50"></path><mask id="divider1-2" mask-type="alpha" maskUnits="userSpaceOnUse" x="-1" y="68" width="1784" height="198"><path d="M-1 69h1784v197H-1V69z" fill="#e05e50"></path></mask><g mask="url(#divider1-2)"><path d="M901.451 104.575l.335.371-.335-.371zm-75.905 68.55l-.335-.371.335.371zM109 208.347v-.5h-.5v.5h.5zm0 1.369h-.5v.5h.5v-.5zm734.458-35.575l.335.371-.335-.371zm75.904-68.55l-.335-.371.335.371zM1754.85 70.37v.5h.5v-.5h-.5zm0-1.37h.5v-.5h-.5v.5zm-812.146 63.038l.336.37-.336-.37zm-75.932 68.839l-.336-.371.336.371zm-716.804 35.37v-.5h-.5v.5h.5zm0 1.375h-.5v.5h.5v-.5zm734.722-35.725l.336.37-.336-.37zm75.932-68.839l-.336-.371.336.371zm835.788-35.37v.5h.5v-.5h-.5zm0-1.375h.5v-.5h-.5v.5zm-811.55 63.481l-.335-.371.335.371zm-75.932 68.55l.335.371-.335-.371zm-716.805 35.221v-.5h-.5v.5h.5zm0 1.37h-.5v.5h.5v-.5zm734.723-35.576l.335.371-.335-.371zm75.934-68.549l-.34-.371.34.371zm835.78-35.222v.5h.5v-.5h-.5zm0-1.369h.5v-.5h-.5v.5zm-936.774-19.272c25.261-22.813 58.113-35.446 92.18-35.446v-1c-34.314 0-67.405 12.725-92.851 35.704l.671.742zm-75.905 68.55l75.905-68.55-.671-.742-75.904 68.55.67.742zm-91.93 35.351c33.974 0 66.737-12.599 91.93-35.351l-.67-.742c-25.01 22.586-57.534 35.093-91.26 35.093v1zm-624.951 0h624.951v-1H109v1zm.5.869v-1.369h-1v1.369h1zm641.442-.5H109v1h641.942v-1zm92.18-35.446a137.54 137.54 0 0 1-92.18 35.446v1a138.54 138.54 0 0 0 92.851-35.704l-.671-.742zm75.905-68.55l-75.905 68.55.671.742 75.904-68.55-.67-.742zm91.933-35.35c-33.977 0-66.74 12.598-91.933 35.351l.67.742a136.17 136.17 0 0 1 91.263-35.092v-1zm743.89 0h-743.89v1h743.89v-1zm-.5-.87v1.37h1V69h-1zm-760.384.5h760.884v-1H993.966v1zm-50.926 62.908c25.271-22.91 58.13-35.596 92.21-35.596v-1c-34.32 0-67.427 12.779-92.882 35.856l.672.74zm-75.932 68.839l75.932-68.839-.672-.74-75.932 68.838.672.741zm-91.964 35.5c33.987 0 66.762-12.652 91.964-35.5l-.672-.741c-25.018 22.682-57.554 35.241-91.292 35.241v1zm-625.176 0h625.176v-1H149.968v1zm.5.875v-1.375h-1v1.375h1zm641.673-.5H149.968v1h642.173v-1zm92.213-35.596c-25.271 22.91-58.134 35.596-92.213 35.596v1a138.29 138.29 0 0 0 92.885-35.855l-.672-.741zm75.932-68.839l-75.932 68.839.672.741 75.932-68.839-.672-.741zm91.964-35.499c-33.99 0-66.761 12.651-91.964 35.499l.672.741c25.019-22.681 57.552-35.24 91.292-35.24v-1zm744.16 0h-744.16v1h744.16v-1zm-.5-.875v1.375h1v-1.375h-1zm-760.66.5h761.16v-1h-761.16v1zm-50.055 63.352c25.275-22.814 58.135-35.446 92.215-35.446v-1c-34.33 0-67.43 12.724-92.885 35.704l.67.742zm-75.932 68.55l75.932-68.55-.67-.742-75.932 68.55.67.742zm-91.964 35.35c33.987 0 66.761-12.598 91.964-35.35l-.67-.742c-25.019 22.586-57.555 35.092-91.294 35.092v1zm-625.176 0h625.176v-1H192.123v1zm.5.87v-1.37h-1v1.37h1zm641.674-.5H192.123v1h642.174v-1zm92.214-35.447c-25.271 22.814-58.135 35.447-92.214 35.447v1c34.326 0 67.429-12.725 92.884-35.705l-.67-.742zm75.929-68.549l-75.929 68.549.67.742 75.929-68.549-.67-.742zm91.97-35.351c-33.99 0-66.76 12.599-91.97 35.351l.67.742c25.02-22.586 57.56-35.093 91.3-35.093v-1zm744.15 0h-744.15v1h744.15v-1zm-.5-.869v1.369h1v-1.369h-1zm-760.65.5h761.15v-1h-761.15v1zM109 209.622h0v-1 1z" fill="url(#divider1-3)"></path></g></g><defs><linearGradient id="divider1-3" x1="166" y1="253.5" x2="1770" y2="69" gradientUnits="userSpaceOnUse"><stop stop-color="#68a3a7" stop-opacity="0"></stop><stop offset=".303" stop-color="#68a3a7"></stop><stop offset=".443" stop-color="#36c"></stop><stop offset=".543" stop-color="#d8a76e"></stop><stop offset="1" stop-color="#d8a76e" stop-opacity="0"></stop></linearGradient></defs></svg>
          <img className='sliderimg' src={slider} alt="slider" />
          <img className='sliderbg' src={sliderbg} alt="slider" />

          <div className="slider-card">
            <h1>GSS LIFESCIENCES</h1>
            {/* <div className="profile-container">
              <h1 className="float-text">{animatedText}</h1>
            </div> */}
            <h4>Advancing Health Through Innovation</h4>
            <p>Pharmaceutical Research & Development of Quality
              Product</p>
            {/* <a href="#">Contact us</a> */}
          </div>
        </div>

        <section className="about">
          <div className="about-body">
            <div className="about__perfil">
              <div className="about__image">
                <img
                  src={about}
                  alt="image"
                  className="about__img"
                  onMouseMove={handleMouseMove}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => {
                    setIsHovered(false);
                    setPosition({ x: 0, y: 0 }); // Reset position
                  }}
                  style={{
                    transform: `translate(${position.x * 0.2}px, ${position.y * 0.2}px)`,
                    transition: isHovered ? "transform 1s ease-out" : "transform 1s ease-out",
                  }}
                />
                <div className="about__shadow" />
              </div>
            </div>
            <div className="about-card">
              <h3>About GSS LIFESCIENCES</h3>
              <p>  GSS Lifesciences was established in 2018 by Mr. Niraj Soni, with a vision to advance healthcare solutions in India. From our base in Gujarat, we are dedicated to providing high-quality pharmaceutical research and development. Our core mission is to improve patient outcomes through innovation and a commitment to excellence.</p>
              <p>  Since our inception, we have focused on building a strong foundation of scientific expertise and operational efficiency. Our goal is to become a leading provider of comprehensive life sciences solutions. Deal with <b style={{ color: "#fff" }}>WHO - GMP approved products</b> which show the highest quality of medicines.</p>
              <Link to={"/about"}> <span>Learn More</span></Link>
            </div>
          </div>



        </section>

        <section className="products">
          <div className="section-title">
            {/* <h4>Our products</h4> */}
            <h3>Explore our products</h3>
            <p>Committed to Excellence in Pharmaceutical Product</p>
          </div>

          <div className="product-body">
            <div className="product-card">
              <img src={p1} alt="Multivitamin range" />
              <div className="product-card-text">
                <h3>Multivitamin range
                </h3>
                <p>Vitamins are essential for the proper functioning of the nerves. Vitamin deficiency leads to a decrease in the production of myelin sheath. It is this membrane that is responsible for the preservation of nerve cells. Lack of vitamins reduces energy metabolism and destroys nerve cells. As a result, a person has problems with numbness, depression, and cognitive decline.</p>
                {/* <a href="#">Learn More <span>&#x21e8;</span></a> */}
                <Link to={"/product-range/#multivitaminRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>
            <div className="product-card">
              <img src={p3} alt="Antidepressent range" />
              <div className="product-card-text">
                <h3>Antidepressent range
                </h3>
                <p>Antidepressants are a class of medications used to treat depression and other mental health conditions. They work by affecting neurotransmitters (chemical messengers in the brain) that play a role in mood regulation, such as serotonin and norepinephrine.</p>
                <Link to={"/product-range/#antidepressentRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>
            <div className="product-card">
              <img src={p2} alt="Neuropathy Pain Management" />
              <div className="product-card-text">
                <h3>Neuropathy Pain Management
                </h3>
                <p>Neuropathic pain is nerve pain that can happen if your nervous system malfunctions or gets damaged. You can feel pain from any of the various levels of your nervous system, including your peripheral nerves, your spinal cord and your brain. </p>
                <Link to={"/product-range/#neuropathyManagement"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>
            <div className="product-card">
              <img src={p5} alt="Anti Epileptic range" />
              <div className="product-card-text">
                <h3>Anti Epileptic range
                </h3>
                <p>Anti-epileptic drugs are used to treat and prevent seizures, which are sudden, uncontrolled electrical disturbances in the brain that can cause a variety of symptoms, including loss of consciousness, muscle spasms, and altered sensations. These medications work by altering the electrical activity in the brain, either by decreasing excitation or enhancing inhibition, to prevent seizures from occurring or to reduce their severity.</p>
                <Link to={"/product-range/#antiEpilepticRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>

            </div>
            <div className="product-card">
              <img src={p8} alt="Anti Migraine Range" />
              <div className="product-card-text">
                <h3>Anti Migraine Range
                </h3>
                <p>Antimigraine drugs are medications used to prevent or lessen the intensity of migraine headaches, which are characterized by symptoms like nausea, vomiting, and sensitivity to light. These drugs include various types such as triptans, β-blockers, anticonvulsants, and others, aimed at treating acute migraine episodes or preventing them.</p>
                <Link to={"/product-range/#antiMigraineRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>

            </div>
            <div className="product-card">
              <img src={p9} alt="Anti Psychotic range" />
              <div className="product-card-text">
                <h3>Anti Psychotic range
                </h3>
                <p>Antipsychotics are medications primarily used to treat psychosis, a condition characterized by hallucinations, delusions, and disorganized thoughts. Antipsychotic medications work by influencing neurotransmitters, especially dopamine, in the brain. They block dopamine receptors, which helps to reduce the overactivity of dopamine pathways associated with psychotic symptoms.</p>
                <Link to={"/product-range/#antiPsychoticRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>

            </div>
            <div className="product-card">
              <img src={p4} alt="Anti Alzheimer Range " />
              <div className="product-card-text">
                <h3>Anti Alzheimer Range            </h3>
                <p>Alzheimer's disease is a progressive neurodegenerative disorder that primarily affects memory and thinking skills, eventually impacting daily life. </p>
                <Link to={"/product-range/#alzhiemersManagement"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>

            <div className="product-card">
              <img src={p6} alt="Anti Vertigo range" />
              <div className="product-card-text">
                <h3>Anti Vertigo range</h3>
                <p>Anti-vertigo agents, also known as vestibular suppressants, are medications used to relieve the symptoms of vertigo, a sensation of spinning or dizziness, and associated nausea and vomiting. These drugs work by modulating the vestibular sensory network, reducing the transmission of sensory information related to vertigo episodes. </p>
                <Link to={"/product-range/#antiVertigoRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>
            <div className="product-card">
              <img src={p7} alt="PPIs" />
              <div className="product-card-text">
                <h3>PPIs</h3>
                <p>Proton pump inhibitors (PPIs) are a class of drugs that reduce stomach acid production. They work by blocking the hydrogen-potassium ATPase pump, also known as the proton pump, which is responsible for secreting acid in the stomach. PPIs are commonly used to treat conditions like acid reflux (GERD), peptic ulcers, and in combination with antibiotics to eradicate Helicobacter pylori infections. </p>
                <Link to={"/product-range/#ppiRange"}>Learn More <span>&#x21e8;</span></Link>
              </div>
            </div>

          </div>
        </section>

        <section className="contact">
          <div className="section-title">
            {/* <h4>Contact Us</h4> */}
            <h3>get in touch</h3>
            <p>Let's discuss your pharmaceutical needs</p>
          </div>
          <div className="contact-body">
            <div className="contact-details">

              <div className="contact-details-text">
                <a href="tel:919825966404" className="flex items-center mb-6">
                  <svg
                    width={30}
                    height={30}
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.3092 18.3098C22.0157 18.198 21.8689 18.1421 21.7145 18.1287C21.56 18.1154 21.4058 18.1453 21.0975 18.205L17.8126 18.8416C17.4392 18.9139 17.2525 18.9501 17.0616 18.9206C16.8707 18.891 16.7141 18.8058 16.4008 18.6353C13.8644 17.2551 12.1853 15.6617 11.1192 13.3695C10.9964 13.1055 10.935 12.9735 10.9133 12.8017C10.8917 12.6298 10.9218 12.4684 10.982 12.1456L11.6196 8.72559C11.6759 8.42342 11.7041 8.27233 11.6908 8.12115C11.6775 7.96998 11.6234 7.82612 11.5153 7.5384L10.6314 5.18758C10.37 4.49217 10.2392 4.14447 9.95437 3.94723C9.6695 3.75 9.29804 3.75 8.5551 3.75H5.85778C4.58478 3.75 3.58264 4.8018 3.77336 6.06012C4.24735 9.20085 5.64674 14.8966 9.73544 18.9853C14.0295 23.2794 20.2151 25.1426 23.6187 25.884C24.9335 26.1696 26.0993 25.1448 26.0993 23.7985V21.2824C26.0993 20.5428 26.0993 20.173 25.9034 19.8888C25.7076 19.6046 25.362 19.4729 24.6708 19.2096L22.3092 18.3098Z"
                      stroke="#e05e50"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <h5 className="text-black text-base font-normal leading-6 ml-5">
                    +91-9825966404
                  </h5>
                </a>
                <a
                  href="mailto:gsslifesciences@gmail.com"
                  className="flex items-center mb-6"
                >
                  <svg
                    width={30}
                    height={30}
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.81501 8.75L10.1985 13.6191C12.8358 15.2015 14.1544 15.9927 15.6032 15.9582C17.0519 15.9237 18.3315 15.0707 20.8905 13.3647L27.185 8.75M12.5 25H17.5C22.214 25 24.5711 25 26.0355 23.5355C27.5 22.0711 27.5 19.714 27.5 15C27.5 10.286 27.5 7.92893 26.0355 6.46447C24.5711 5 22.214 5 17.5 5H12.5C7.78595 5 5.42893 5 3.96447 6.46447C2.5 7.92893 2.5 10.286 2.5 15C2.5 19.714 2.5 22.0711 3.96447 23.5355C5.42893 25 7.78595 25 12.5 25Z"
                      stroke="#e05e50"
                      strokeWidth={2}
                      strokeLinecap="round"
                    />
                  </svg>
                  <h5 className="text-black text-base font-normal leading-6 ml-5">
                    gsslifesciences@gmail.com
                  </h5>
                </a>
                <a href="https://www.google.com/maps/place/Vadvali+Mehta+Pole/@23.0306802,72.5728351,14.46z/data=!4m6!3m5!1s0x395e8534399d8e91:0x74e710d0ac8e1878!8m2!3d23.037389!4d72.579648!16s%2Fg%2F11pwvgh_8p?hl=en&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D" className="flex items-center">
                  <div>
                    <svg
                      width={30}
                      height={30}
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25 12.9169C25 17.716 21.1939 21.5832 18.2779 24.9828C16.8385 26.6609 16.1188 27.5 15 27.5C13.8812 27.5 13.1615 26.6609 11.7221 24.9828C8.80612 21.5832 5 17.716 5 12.9169C5 10.1542 6.05357 7.5046 7.92893 5.55105C9.8043 3.59749 12.3478 2.5 15 2.5C17.6522 2.5 20.1957 3.59749 22.0711 5.55105C23.9464 7.5046 25 10.1542 25 12.9169Z"
                        stroke="#e05e50"
                        strokeWidth={2}
                      />
                      <path
                        d="M17.5 11.6148C17.5 13.0531 16.3807 14.219 15 14.219C13.6193 14.219 12.5 13.0531 12.5 11.6148C12.5 10.1765 13.6193 9.01058 15 9.01058C16.3807 9.01058 17.5 10.1765 17.5 11.6148Z"
                        stroke="#e05e50"
                        strokeWidth={2}
                      />
                    </svg>
                  </div>

                  <h5 className="text-black text-base font-normal leading-6 ml-5">
                    3158, Vadwali Mehta Pole, Shahpur,
                    Ahmedabad, Gujarat, 380001
                  </h5>
                </a>
              </div>

            </div>
            <img src={contact} alt="contact" />

            <form action="POST" ref={form}>
              <input type="text" placeholder='First Name' name='FirstName'
                value={userData.Name}
                onChange={postUserData}
                required />
              <input type="text" id="" placeholder='Last Name' name='LastName'
                value={userData.LastName}
                onChange={postUserData}
                required />
              <input type="email" id="" placeholder='Email' name='Email'
                value={userData.Email}
                onChange={postUserData}
                required />
              <input type="text" id="" placeholder='Mobile' name='Mobile'
                value={userData.Mobile}
                onChange={postUserData}
                required />
              <textarea id="" placeholder='Message' name="Message" rows="5"
                value={userData.Message}
                onChange={postUserData}
                required></textarea>
              <button onClick={SubmitData} type="submit">Send</button>
            </form>

          </div>

        </section>
      </>

    </div>
  )
}

export default Home